var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3 mt-3" },
    [
      _c("validation-observer", { ref: "observer" }, [
        !_vm.isPreview
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("validation-provider", {
                    attrs: {
                      "custom-messages": {
                        min_value: "La cantidad mínima debe ser 1.",
                        max_value: "La cantidad máxima debe ser 100."
                      },
                      rules: "required|numeric|max_value:100|min_value:1"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  error: errors[0],
                                  label:
                                    "¿Cuantas localidades podrán ser añadidas?",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.model.quantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "quantity", _vm._n($$v))
                                  },
                                  expression: "model.quantity"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1683325224
                    )
                  })
                ],
                1
              ),
              _c("div", { staticClass: "col-6" })
            ])
          : _vm._e(),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _vm.isReadOnly
                ? _c("div", [
                    _c("label", { staticClass: "data-label" }, [
                      _vm._v(" Dirección (Línea 1) ")
                    ]),
                    _c("input", {
                      staticClass: "form-control disabled",
                      attrs: { disabled: true, type: "text" }
                    })
                  ])
                : _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": "El campo es requerido.",
                                disabled: true,
                                error: errors[0],
                                label: "Dirección (Línea 1)"
                              },
                              model: {
                                value: _vm.model.addressLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "addressLine1", $$v)
                                },
                                expression: "model.addressLine1"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _vm.isReadOnly
                ? _c("div", [
                    _c("label", { staticClass: "data-label" }, [
                      _vm._v(" Dirección (Línea 2) ")
                    ]),
                    _c("input", {
                      staticClass: "form-control disabled",
                      attrs: { disabled: true, type: "text" }
                    })
                  ])
                : _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": "El campo es requerido.",
                                disabled: true,
                                error: errors[0],
                                label: "Dirección (Línea 2)"
                              },
                              model: {
                                value: _vm.model.addressLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "addressLine2", $$v)
                                },
                                expression: "model.addressLine2"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("ValidationProvider", {
                attrs: { rules: _vm.isReadOnly ? "" : "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-drop-down", {
                          attrs: {
                            id: "participantType",
                            clearable: true,
                            "custom-error-msg": "El campo es requerido",
                            disabled: true,
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "name",
                            label: "Estado",
                            options: _vm.states,
                            placeholder: "Seleccione Estado"
                          },
                          on: { input: _vm.onStateChange },
                          model: {
                            value: _vm.model.state,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "state", $$v)
                            },
                            expression: "model.state"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("ValidationProvider", {
                attrs: { rules: _vm.isReadOnly ? "" : "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-drop-down", {
                          attrs: {
                            id: "participantType",
                            clearable: true,
                            "custom-error-msg": "El campo es requerido",
                            disabled: true,
                            error: errors[0],
                            fieldkey: "id",
                            fieldname: "name",
                            label: "Municipio",
                            options: _vm.municipalities,
                            placeholder: "Seleccione Municipio"
                          },
                          model: {
                            value: _vm.model.municipality,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "municipality", $$v)
                            },
                            expression: "model.municipality"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _vm.isReadOnly
                ? _c("div", [
                    _c("label", { staticClass: "data-label" }, [
                      _vm._v(" Código Postal ")
                    ]),
                    _c("input", {
                      staticClass: "form-control disabled",
                      attrs: { disabled: true, type: "text" }
                    })
                  ])
                : _c("ValidationProvider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": "El campo es requerido",
                                disabled: true,
                                error: errors[0],
                                label: "Código Postal",
                                "mask-type": "ZipcodeExt"
                              },
                              model: {
                                value: _vm.model.postalCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "postalCode", $$v)
                                },
                                expression: "model.postalCode"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
            ],
            1
          ),
          _c("div", { staticClass: "col-12 my-2 p-3 document-bg rounded-lg" }, [
            _c("label", { staticClass: "data-label d-block mb-2" }, [
              _vm._v(
                " Fotos por dentro y fuera (Incluyendo los baños y lugar confidencial donde se mantienen los expedientes de los estudiante) "
              )
            ]),
            _c(
              "div",
              {
                staticClass: "col-12 p-3 document-bg rounded-lg",
                staticStyle: { "background-color": "#F1F6F4" }
              },
              [
                _vm.isReadOnly
                  ? _c(
                      "div",
                      [
                        _c("label", { staticClass: "data-label" }, [
                          _vm._v(" Archivo ")
                        ]),
                        _c("action-button", {
                          staticClass: "w-100 disabled",
                          attrs: {
                            disabled: true,
                            i: "fas fa-file-plus",
                            text: "Presione aquí para anejar documento",
                            variant: "outline-grey mr-3 pl-3 pr-4"
                          }
                        })
                      ],
                      1
                    )
                  : _c("validation-provider", {
                      staticClass: "w-100",
                      attrs: { name: "Documento", rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-file-input", {
                                ref: "fileInput",
                                attrs: {
                                  accept: ".pdf",
                                  "attachment-id": _vm.model.Id,
                                  "custom-error-msg": "documento es requerido",
                                  "display-style": "normal",
                                  error: errors[0],
                                  label: "Archivo:",
                                  "label-position": "left",
                                  name: _vm.model.documentName,
                                  "on-download": () => {}
                                },
                                model: {
                                  value: _vm.model.attachment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "attachment", $$v)
                                  },
                                  expression: "model.attachment"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }